@if (store.hasError()){
  <p>Failed to fetch refill answers</p>
} @else if(refillResponsesDisplay().length) {
  @for (answerData of refillResponsesDisplay(); track answerData.id; let i = $index) {
  <div class="flow">
    <ui-accordion [openOnRender]="i === 0" (toggle)="onAccordionToggle(i, $event)" style="margin-bottom: var(--space-2x)">
      <div class="header" slot="heading">
        @if (accordionStates[i]) {
          {{answerData.medication}}
        } @else {
          {{answerData.mailOrderFillRequestID}} | {{answerData.medication}}
          @if (answerData.processedDate) { | Processed Date: {{answerData.processedDate | date: 'dd-MM-yyyy'}}}
        }
      </div>
      <p class="sub-header">Refill Request Date : {{answerData.created | date: 'dd/MM/yyyy'}}</p>
      <p class="sub-header">Refill Reference : {{answerData.mailOrderFillRequestID}}</p>
      @for (answer of answerData.answers; track answer.id) {
        <div [class.is-child]="answer.is_child">
          <answer-display [question]="answer.question" [answers]="answer.answer"></answer-display>
        </div>
      }

      <button [disabled]="!answerData.isOpen" (click)="switchTab('mailorder')" style="margin-top: var(--space-3x)">Process Refill Request</button>
    </ui-accordion>
  </div>
}
}@else {
  <p>No refill answers</p>
}
